import React, { useState, useEffect } from 'react';
import { Grid, TextField } from '@mui/material';
import AddEditDialog from './AddEditDialog';

interface CreateDirectoryDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (directoryName: string) => void;
    error?: Error;
}

const CreateDirectoryDialog: React.FC<CreateDirectoryDialogProps> = (props) => {
    const { isOpen, onClose, onSave, error } = props;
    const [directoryName, setDirectoryName] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setDirectoryName('');
            setIsSubmitted(false);
        }
    }, [isOpen]);

    const handleSave = () => {
        setIsSubmitted(true);
        onSave(directoryName);
    };

    const handleCancel = () => {
        setDirectoryName('');
        onClose();
    };

    const isFormValid = () => {
        return directoryName.trim().length > 0;
    };

    const handleError = () => {
        setIsSubmitted(false);
    };

    return (
        <AddEditDialog
            isOpen={isOpen}
            isSubmitted={isSubmitted}
            entityName="Directory"
            onClose={handleCancel}
            onSave={handleSave}
            validate={isFormValid}
            onError={handleError}
            error={error}
            maxWidth='sm'
        >
            <Grid container spacing={2} width={'300px'}>
                <Grid item xs={12}>
                    <TextField
                        label="Directory Name"
                        value={directoryName}
                        onChange={(e) => setDirectoryName(e.target.value)}
                        fullWidth
                        autoFocus
                        autoComplete="off"
                        disabled={isSubmitted}
                        variant="standard"
                        inputProps={{
                            'aria-label': 'name of the directory to create',
                        }}
                        data-cy="create-directory-name-input"
                    />
                </Grid>
           </Grid>
        </AddEditDialog>
    );
};

export default CreateDirectoryDialog;
